import { ITariffMutations } from './mutations.types';
import { ITariffData } from '@/models';
import { ITariffState } from '../tariff.types';

export const mutations: ITariffMutations = {
  SET_TARIFFS(state: ITariffState, payload: ITariffData[]): void {
    state.tariffs = payload;
  },

  UPSERT_TARIFF(state: ITariffState, payload: ITariffData): void {
    const index = state.tariffs.findIndex(
      (tariff: ITariffData) => tariff.id === payload.id
    );

    if (index === -1) {
      state.tariffs.unshift(payload);
    } else {
      // will update reference of tariffs items
      state.tariffs.splice(index, 1, payload);
    }
  },

  REMOVE_TARIFF(state: ITariffState, payload: number): void {
    const index = state.tariffs.findIndex(
      (tariff: ITariffData) => tariff.id === payload
    );

    state.tariffs.splice(index, 1);
  },

  SET_LAST_PROMISE(state: ITariffState, payload: Promise<any>): void {
    state.lastPromise = payload;
  }
};
